import MergedContactEnrollmentSetting from 'automation-ui-canvas/components/settings/v2/MergedContactEnrollmentSetting';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ExecutionTimingSetting from 'automation-ui-canvas/components/settings/v2/ExecutionTimingSetting';
import HolidayManagementSetting from 'automation-ui-canvas/components/settings/v2/HolidayManagementSetting';
import EnrollmentNotificationSetting from 'automation-ui-canvas/components/settings/v2/EnrollmentNotificationSetting';
import UnenrollmentSetting from 'automation-ui-canvas/components/settings/v2/UnenrollmentSetting';
import SalesforceEnrollmentSetting from 'automation-ui-canvas/components/settings/v2/SalesforceSettings';
import IssuesNotificationSetting from 'automation-ui-canvas/components/settings/v2/IssuesNotificationSetting';
import NotificationRecipientsSetting from 'automation-ui-canvas/components/settings/v2/NotificationRecipientsSetting';
import { SFDC_KEY } from 'automation-ui-canvas/queries/SalesforceEnabledPortalSettingQuery';
import UnenrollmentTriggerSettingV2 from 'automation-ui-canvas/components/settings/v2/UnenrollmentTriggerSettingV2';
import ClassicUnenrollmentSetting from 'automation-ui-canvas/components/settings/v2/ClassicUnenrollmentSetting';
import ScheduledDisableAtSetting from 'automation-ui-canvas/components/settings/v2/ScheduledDisableAtSetting';
import MetricsToggleSetting from 'automation-ui-canvas/components/settings/v2/MetricsToggleSetting';
import { METRICS_LIMITS } from 'automation-ui-canvas/constants/Gates';
import { jsx as _jsx } from "react/jsx-runtime";
const getPerformanceSection = () => {
  return {
    id: 'performance',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.performance"
    }),
    modules: [{
      id: 'issuesNotificationSetting',
      Component: IssuesNotificationSetting
    }, {
      id: 'enrollmentNotificationSetting',
      Component: EnrollmentNotificationSetting
    }, {
      id: 'notificationRecipientsSetting',
      Component: NotificationRecipientsSetting,
      getIsVisible: ({
        settings
      }) => {
        return !!settings && !!settings.notifications && (settings.notifications.notificationConfigs.ENROLLMENT_DIGEST.isEnabled || settings.notifications.notificationConfigs.ISSUE_NOTIFICATION.isEnabled || settings.notifications.notificationConfigs.AI_BASED_ENROLLMENT_DIGEST.isEnabled);
      }
    }, {
      id: 'metricsToggleSetting',
      Component: MetricsToggleSetting,
      getIsVisible: ({
        isUngated
      }) => {
        return isUngated(METRICS_LIMITS);
      }
    }]
  };
};
export const getClassicEnrollmentSection = () => {
  return {
    id: 'enrollment',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.enrollment"
    }),
    modules: [{
      id: 'mergedContactEnrollment',
      Component: MergedContactEnrollmentSetting
    }, {
      id: 'salesforceEnrollment',
      Component: SalesforceEnrollmentSetting,
      getIsVisible: ({
        portalSettings
      }) => {
        return !!portalSettings && portalSettings.settings.some(setting => setting.key === SFDC_KEY && setting.value === 'true');
      }
    }]
  };
};
export const getClassicSettings = () => {
  return [{
    id: 'general',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.timing"
    }),
    modules: [{
      id: 'executionTiming',
      Component: ExecutionTimingSetting
    }, {
      id: 'holidayManagement',
      Component: HolidayManagementSetting
    }, {
      id: 'scheduledDisableAt',
      Component: ScheduledDisableAtSetting
    }]
  }, getPerformanceSection(), {
    id: 'connections',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.connections"
    }),
    modules: [{
      id: 'unenrollmentSetting',
      Component: UnenrollmentSetting
    }]
  }];
};
export const getUnenrollmentSection = ({
  isClassicWorkflow
}) => {
  if (isClassicWorkflow) {
    return {
      id: 'unenrollment',
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingsV2.unenrollment"
      }),
      modules: [{
        id: 'unenrollmentTriggerSetting',
        Component: ClassicUnenrollmentSetting
      }]
    };
  }
  return {
    id: 'unenrollment',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.unenrollment"
    }),
    modules: [{
      id: 'unenrollmentTriggerSetting',
      Component: UnenrollmentTriggerSettingV2
    }]
  };
};
export const getPlatformSettings = () => {
  return [{
    id: 'actions',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.timing"
    }),
    modules: [{
      id: 'executionTiming',
      Component: ExecutionTimingSetting
    }, {
      id: 'holidayManagement',
      Component: HolidayManagementSetting
    }, {
      id: 'scheduledDisableAt',
      Component: ScheduledDisableAtSetting
    }]
  }, getPerformanceSection()];
};